<template>
  <MetricsSummaryWithLoader
    :loading="loading"
    :number-of-summary-skeletons="2"
    totals-label-width="151px"
    :summaries="summaries"
    :project-name="projectName"
    :date-range="dateRange"
  />
</template>

<script setup>
import MetricsSummaryWithLoader from '@/components/insights/Metrics/MetricsSummaryWithLoader.vue';
import { computed } from 'vue';
import { isEmpty } from 'lodash-es';
import { numberWithCommas, formatTooltipValue } from '@/helpers/formatters';
import { useColors } from '@/composables/colors';

const props = defineProps({
  loading: {
    type: Boolean,
    default: false,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  tooltips: {
    type: Object,
    default: () => ({}),
  },
  projectName: {
    type: String,
    default: '',
  },
  dateRange: {
    type: Object,
    default: () => ({}),
  },
});
const appsForOneHire = computed(() => {
  const total = props.data?.total || {};

  if (typeof total.review !== 'number' || typeof total.hired !== 'number' || total.hired === 0) {
    return '-';
  }

  const appsPerHire = total.review / total.hired;
  return Number.isFinite(appsPerHire) ? numberWithCommas(Math.round(appsPerHire)) : '-';
});

const { brandPrimary, textDarkest } = useColors();

const summaries = computed(() => {
  if (isEmpty(props.data)) return [];

  const {
    total,
  } = props.data || {};

  const passthroughOverall = typeof total?.hired === 'number' && typeof total?.review === 'number' && total.review > 0
    ? formatTooltipValue((total.hired / total.review) * 100, 'percent')
    : '-';

  const baseSummaries = [
    {
      id: 'passthrough-overall',
      tooltipKey: 'passthrough-overall',
      label: 'Overall Pass-Through',
      color: brandPrimary.value,
      value: passthroughOverall,
    },
    {
      id: 'apps-for-one-hire',
      tooltipKey: 'passthrough-apps-for-one-hire',
      label: 'Applications needed to make 1 Hire',
      color: textDarkest.value,
      value: appsForOneHire.value,
    },
  ];

  return baseSummaries.map((summary) => {
    const { body_r: html, mode } = props.tooltips?.[summary.tooltipKey] || {};
    return {
      ...summary,
      tooltip: { html, mode, key: summary.tooltipKey },
    };
  });
});
</script>
